export const DeveloperToolsModuleTranslations: Array<string> = [
  'Admin.SuccessfullyDeleted',
  'Msg.Yes',
  'Msg.No',
  'Msg.Delete',
  'Msg.Close',

  // Event Log
  'Admin.Log.LogId',
  'Admin.Log.Date',
  'Admin.Log.Level',
  'Admin.Log.Labels',
  'Admin.Log.Title',
  'Admin.Log.Description',
  'Admin.Log.Domain',
  'Admin.Log.Logger',
  'Admin.Log.UserId',
  'Admin.Log.Username',
  'Admin.Log.SessionId',
  'Admin.Log.CartId',
  'Admin.Log.CartCompositeNumber',
  'Admin.Log.AppPoolIP',
  'Admin.Log.Exception',
  'xsltDateModified',
  'xsltDateModifiedFrom',
  'xsltDateModifiedTo',
  'xmlEventLog',
  'Admin.Log.Back',
  'xmlActions',
  'Admin.Log.ReloadLog',
  'Admin.Log.DescriptionSearchConditionMessage',
  'Admin.Log.Details',
  'Admin.Log.DateIsShownForServerTimezoneMessage',
  'Admin.Log.QuickSearch',
  'Admin.Log.FilterIdLargerThan',
  'Admin.Log.UtcDatetimeFrom',
  'Admin.Log.UtcDatetimeTo',
  'Admin.Log.DatetimeMustBeInIsoFormatTimezoneCanBeSkipped',
  'Admin.CustomerActions.Loading',
  'Admin.PromoImport.Stop',
  'Admin.CopyToClipboard',

  // VC Diagnostics
  'xmlVCLog',
  'Admin.VCLog.QuickSearch',
  'Admin.VCLog.Synchronization',
  'Admin.VCLog.Configuration',
  'Admin.VCLog.Pricing',
  'Admin.VCLog.DocumentPricing',
  'Admin.VCLog.Customizing',
  'Admin.VCLog.Authorization',
  'Admin.VCLog.Labels.Actions',
  'Admin.VCLog.Labels.Id',
  'Admin.VCLog.Labels.Date',
  'Admin.VCLog.Labels.UserName',
  'Admin.VCLog.Labels.SessionId',
  'Admin.VCLog.Labels.Description',
  'Admin.VCLog.Labels.Domain',
  'Admin.VCLog.Labels.Label',
  'Admin.VCLog.Labels.URL',
  'Admin.VCLog.Labels.KBNumber',
  'Admin.VCLog.Labels.KBSyncGuid',
  'Admin.VCLog.Labels.Payload',
  'Admin.VCLog.Labels.FetchPayload',
  'Admin.VCLog.View',
  'Admin.VCLog.Copied',
  'Admin.VCLog.LogLevel.EnableLoggingAllCalls',
  'Admin.VCLog.LogLevel.EnableLoggingAllCalls.Info',
  'Admin.VCLog.LogLevel.EnableLoggingAllCalls.AlertInfo',

  // KB Diagnostics
  'xmlKBDiagnostics',
  'Admin.KBDiagnostics.FailedData',
  'Admin.KBDiagnostics.FailedData.InfoMessage',
  'Admin.KBDiagnostics.FailedData.QuickSearch',
  'Admin.KBDiagnostics.FailedData.ResyncAll',
  'Admin.KBDiagnostics.FailedData.DeleteAll',
  'Admin.KBDiagnostics.FailedData.KBId',
  'Admin.KBDiagnostics.FailedData.FirstFailed',
  'Admin.KBDiagnostics.FailedData.LastFailed',
  'Admin.KBDiagnostics.FailedData.ErrorMessage',
  'Admin.KBDiagnostics.FailedData.Resync',
  'Admin.KBDiagnostics.ReloadData',
  'Admin.KBDiagnostics.DeleteWarning',
  'Admin.KBDiagnotics.DeleteMsg',
  'Admin.KBDiagnotics.DeleteAllMsg',
  'Admin.KBDiagnotics.ResyncStarted',
  'Admin.KBDiagnotics.Statistics',
  'Admin.KBDiagnotics.Statistics.JobId',
  'Admin.KBDiagnotics.Statistics.KbSyncGuid',
  'Admin.KBDiagnotics.Statistics.TotalNumberOfKbs',
  'Admin.KBDiagnotics.Statistics.SuccessfullySyncedKbs',
  'Admin.KBDiagnotics.Statistics.FailedKbs',
  'Admin.KBDiagnotics.Statistics.StartTime',
  'Admin.KBDiagnotics.Statistics.EndTime',
  'Admin.KBDiagnotics.Statistics.IsJobCanceled',
  'Admin.KBDiagnostics.Statistics.QuickSearch',
  'Admin.KBDiagnostics.Payload',
  'Admin.KBDiagnostics.TranslationPayload',
  'Admin.KBDiagnostics.Payload.KbId',
  'Admin.KBDiagnostics.Payload.FetchPayload',
  'Admin.KBDiagnostics.Payload.FetchTranslationPayload',
  'Admin.KBDiagnostics.Payload.KbJsonPayload',
  'Admin.KBDiagnostics.Payload.Copied',
  'Admin.KBDiagnostics.ManualSync',
  'Admin.KBDiagnostics.ManualSync.SyncByDate',
  'Admin.KBDiagnostics.ManualSync.SyncByKbId',
  'Admin.CPSProvider.ExecuteJobImmediately',
  'Admin.CPSProvider.ExecuteJobInfo',
  'Admin.CPSProvider.ExecuteJob',
  'Admin.CPSProvider.CancelJob',
  'Admin.KBDiagnostics.ManualSync.JobStatus',
  'Admin.KBDiagnostics.ManualSync.JobId',
  'Admin.KBDiagnostics.ManualSync.LastSync',
  'Admin.KBDiagnostics.ManualSync.JobCompletion',
  'Admin.KBDiagnostics.ManualSync.TotalNumberOfKbs',
  'Admin.KBDiagnostics.ManualSync.NumberOfSuccessKbs',
  'Admin.KBDiagnostics.ManualSync.NumberOfFailedKbs',
  'Admin.KBDiagnostics.ManualSync.KnowledgeBases',
  'Admin.KBDiagnostics.ManualSync.SyncStarted',
  'Admin.KBDiagnostics.ManualSync.SyncStopped',
  'Admin.KBDiagnostics.ManualSync.SyncByDateLabel',
  'Admin.KBDiagnostics.ManualSync.SyncByKbIdLabel',
  'Admin.KBDiagnostics.DeleteKbs.AreYouSure',
  'Admin.KBDiagnostics.DeleteKbs.DeletionStatus',
  'Admin.KBDiagnostics.DeleteKbs.SuccessfullyDeleted',
  'Admin.KBDiagnostics.DeleteKbs.FollowingKbsNotDeleted',
  'Admin.KBDiagnostics.DeleteKbs.CheckUsageInfo',
  'Admin.KBDiagnostics.DeleteKbs.KbUsageInformation',
  'Admin.KBDiagnostics.DeleteKbs.KbId',
  'Admin.KBDiagnostics.DeleteKbs.FilterByKbIdOrProductNames',
  'Admin.KBDiagnostics.DeleteKbs.UsedInfoMessage',
  'Admin.KBDiagnostics.DeleteInvalidKbs',
  'Admin.KBDiagnostics.DeleteKbs.ConfirmDeletion',
  'Admin.KBDiagnostics.DeleteKbs.ProductNames',
  'Admin.Msg.CheckUsage',
  'Admin.KBDiagnostics.DeleteKbs.NoKbsSelected',

  // Script Performance
  'xmlScriptPerformance',
  'Admin.ScriptPerformance.QuickSearch',
  'Admin.ScriptPerformance.ScriptName',
  'Admin.ScriptPerformance.longestExecutionTime',
  'Admin.ScriptPerformance.averageExecutionTime',
  'Admin.ScriptPerformance.numberOfExecutions',
  'Admin.ScriptPerformance.ViewChart',
  'Admin.ScriptPerformance.MessageForColoredCells',
  'Admin.ScriptPerformance.ReferToDays',
  'Admin.ScriptPerformance.XAxisLabel',
  'Admin.ScriptPerformance.YAxisLabel',
  'Admin.ScriptPerformance.GraphTitle',
  'Admin.Hangfire.TenantName',

  // Customer Migration
  'xmlCustomerMigration',
  'Admin.CustomerMigration.MappingCustomerRolesTitle',
  'Admin.CustomerMigration.CustomerRoles',
  'Admin.CustomerMigration.PartnerFunction',
  'Admin.CustomerMigration.AddNew',
  'Admin.CustomerMigration.SuccessfullyUpdated',
  'Admin.CustomerMigration.AddPartnerFunction',
  'Admin.CustomerMigration.AddPartnerFunctionName',
  'Admin.CustomerMigration.AddPartnerFunctionKey',
  'Admin.BusinessPartnerFunction.KeyPlaceholder',
  'Admin.CustomerMigration.MappingCustomerFieldsTitle',
  'Admin.CustomerMigration.CustomerFields',
  'Admin.CustomerMigration.BusinessPartnerFields',
  'Admin.CustomerMigration.StandardFields',
  'Admin.CustomerMigration.CustomFields',
  'Admin.CustomerMigration.MigrationDone',
  'Admin.CustomerMigration.MigrationInProgress',
  'Msg.Select',
  'Msg.From',
  'Msg.To',
  'Admin.CustomerMigration.DatabaseSizeExceeded',
  'Admin.BusinessPartnerFunction.KeyPlaceholder',
  'Admin.CustomerMigration.AddBusinesPartnerCustomField',
  'Admin.AddEditBusinessPartnerCustomField.Name',
  'Admin.DataProtection.SensitiveData',
  'Admin.DataProtection.InfoLabel',
  'Admin.AddEditBusinessPartnerCustomField.Label',
  'Admin.BusinessPartners.Permissions',
  'Admin.BusinessPartnerCustomField.SameForAll',
  'Admin.UserCustomField.FieldPermission',
  'Admin.QPEdit.ReadDashOnly',
  'CustomerFieldsPermissions.Editable',
  'Admin.QPEdit.Hidden',
  'Admin.CustomerMigration.Migrate',
  'Admin.CustomerMigration.MappingCustomerCustomFieldToBpStandardFieldMsg',
  'Admin.CustomerMigration.Diagnostics',
  'Admin.CustomerMigration.Mapping',
  'Admin.CustomerMigration.Diagnostics.Scripts',
  'Admin.CustomerMigration.Diagnostics.Templates',
  'Admin.CustomerMigration.Diagnostics.Formulas',
  'Admin.CustomerMigration.Diagnostics.ScriptsTitle',
  'Admin.CustomerMigration.Diagnostics.TemplatesTitle',
  'Admin.CustomerMigration.Diagnostics.FormulasTitle',
  'Admin.CustomerMigration.RollbackWarning',
  'Admin.CustomerMigration.RollbackWarningMessage',
  'Admin.CustomerMigration.RollbackSuccessfull',
  'Admin.CustomerMigration.Rollback',
  'Admin.CustomerMigration.Continue',
  'Admin.CustomerMigration.MigrateWarningDialogMessage',
  'Admin.CustomerMigration.StartingInfoMessage',
  'Admin.CustomerMigration.Diagnostics.TemplateInfo',
  'Msg.Done',
  'Admin.CustomerMigration.DoneWithMigrationWarning',

  // Quote Migration
  'xmlQuoteMigration',
  'Admin.QuoteMigration.Mapping',
  'Admin.QuoteMigration.Migrate',
  'Admin.QuoteMigration.MappingCustomerRolesTitle',
  'Admin.QuoteMigration.MappingQuoteFieldsTitle',
  'Admin.QuoteMigration.MappingCustomerFieldsTitle',
  'QuoteMigration.FilterBy',
  'QuoteMigration.FilterByDateCreated',
  'QuoteMigration.FilterByStatus',
  'QuoteMigration.FilterByDateModified',
  'QuoteMigration.FilterByEffectiveDate',
  'QuoteMigration.FilterByMarket',
  'QuoteMigration.FilterByQuoteNumber',
  'QuoteMigration.SelectValue',
  'QuoteMigration.FilterValue',
  'QuoteMigration.Operator',
  'QuoteMigration.Value',
  'QuoteMigration.SelectMarkets',
  'QuoteMigration.SelectStatuses',
  'QuoteMigration.EnterADate',
  'QuoteMigration.MigrateGeneratedDocuments',
  'QuoteMigration.MigrateQuoteAttachments',
  'QuoteMigration.MigrateAllRevisions',
  'QuoteMigration.MigrateQuoteTables',
  'QuoteMigration.OverwriteQuotes',
  'QuoteMigration.MigrateQuotesWithoutItems',
  'QuoteMigration.MigrateCustomersToInvolvedParties',
  'QuoteMigration.Choose',
  'QuoteMigration.EnterValue',
  'QuoteMigration.DeltaMigrationInfoMsg',
  'Admin.QuoteMigration.StandardQuoteFields',
  'Admin.QuoteMigration.SuccessfullyUpdated',
  'Admin.QuoteMigration.CustomFields',
  'Admin.MigrationTool.LaterThan',
  'Admin.MigrationTool.EarlierThan',
  'Admin.MigrationTool.ExactDate',
  'Admin.MigrationTool.Between',
  'Admin.MigrationTool.Last7Days',
  'Admin.MigrationTool.Last30Days',
  'Admin.MigrationTool.LastYear',
  'Admin.MigrationTool.Last2Years',
  'QuoteMigration.Migrate',
  'Admin.QuoteMigration.MappingCustomerRolesToPartnerFields',
  'Admin.MigrationTool.RequestedBy',
  'Admin.MigrationTool.CreatedBy',
  'Admin.MigrationTool.ShouldEmailWhenDone',
  'Admin.MigrationTool.Progress',
  'Admin.MigrationTool.Status',
  'Admin.QuoteMigration.Jobs',
  'Admin.MigrationTool.ExportExcel',
  'Admin.MigrationTool.Rollback',
  'Admin.MigrationTool.ViewFilters',
  'Admin.MigrationTool.DeleteJob',
  'Admin.MigrationTool.Cancel',
  'Admin.MigrationTool.Delete',
  'Admin.MigrationTool.Restart',
  'Admin.MigrationTool.CannotExportExcel',
  'Admin.QuoteMigration.ActionExecuted',
  'Admin.QuoteMigration.SuccessfullyDeleted',
  'Admin.QuoteMigration.DeleteWarning',
  'Admin.QuoteMigration.FinishMigration',
  'Admin.QuoteMigration.FinishMigrationWarningContent',
  'Admin.QuoteMigration.FinishMigrationSuccess',
  'Admin.QuoteMigration.FilterByNumber.Hint',

  //Application Parameter Settings
  'xmlApplicationParameterSettings',
  'Admin.AppParamSettings.QuickSearch',
  'Admin.AppParamSettings.AddNew',
  'Admin.AppParamSettings.Name',
  'Admin.AppParamSettings.Value',
  'Login.Domain',
  'Admin.AppParamSettings.Reason',
  'Admin.AppParamSettings.Parameter',
  'Admin.AppParamSettings.ApplyChanges',
  'Admin.AppParamSettings.SuccessfullyApplied',
  'Admin.AppParamSettings.ApplyChangesMessage',
  'Admin.SuccessfullyUpdated',
  'Admin.AppParamSettings.SelectDomain',
  'Admin.AppParamSettings.Successfully',
  'Admin.AppParamSettings.ReasonForAdding',
  'Admin.AppParamSettings.ReasonForChanging',
  'Admin.AppParamSettings.Description',
  'Admin.AppParamSettings.CpqTab',
  'Admin.AppParamSettings.NotifierTab',
  'Admin.AppParamSettings.NotifierParameter',

  // Tenant Cache Tool Viewer
  'xmlTenantCacheToolViewer',
  'Admin.TenantCacheToolViewer.ApplicationPool',
  'Admin.TenantCacheToolViewer.RemoveData',
  'Admin.TenantCacheToolViewer.QuickSearch',
  'Admin.TenantCacheToolViewer.KeyName',
  'Admin.TenantCacheToolViewer.ReloadData',
  'Admin.TenantCacheToolViewer.Stop',
  'Admin.TenantCacheToolViewer.RemoveItem.Confirmation',
  'Admin.TenantCacheToolViewer.RemoveData.Confirmation',

  //Sales Area Migration Tool
  'xmlSalesAreaMigration',
  'Admin.SalesAreaMigration.Mappings',
  'Admin.SalesAreaMigration.Filters',
  'Admin.SalesAreaMigration.Jobs',
  'Admin.SalesAreaMigration.MappingSalesAreaFieldsSectionTitle',
  'Admin.SalesAreaMigration.MappingSalesAreaFieldsInfo',
  'Admin.SalesAreaMigration.SalesAreaField',
  'Admin.SalesAreaMigration.Source',
  'Admin.SalesAreaMigration.SuccessfullyUpdated',
  'Admin.SalesAreaMigration.SkipMigratedQuotes',
  'Admin.SalesAreaMigration.Save',
  'Admin.SalesAreaMigration.FinishMigrationWarningContent',
  'Admin.SalesAreaMigration.FinishMigrationSuccess',
  'Admin.SalesAreaMigration.Started',

  //System Performance table
  'xmlSystemPerformanceErrorsAndWarnings',
  'Admin.SystemPerformanceTable.HeaderLabel',
  'Admin.SystemPerformanceTable.Errors',
  'Admin.SystemPerformanceTable.Warnings',
  'Admin.SystemPerformanceTable.Title',
  'Admin.SystemPerformanceTable.Description',
  'Admin.SystemPerformanceTable.Logger',
  'Admin.SystemPerformanceTable.NumberOfOccurrences',
  'Admin.SystemPerformance.GraphTitle',
  'Admin.SystemPerformance.XAxisLabel',
  'Admin.SystemPerformance.YAxisLabel',
  'Admin.SystemPerformance.QuickSearch',
  'Admin.SystemPerformance.InfoMessage'
];
